import { render } from "./AdvancedApp.vue?vue&type=template&id=470afc94&scoped=true"
import script from "./AdvancedApp.vue?vue&type=script&lang=js"
export * from "./AdvancedApp.vue?vue&type=script&lang=js"

import "./AdvancedApp.vue?vue&type=style&index=0&id=470afc94&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-470afc94"

export default script